import React from 'react';
import { IconProps } from '../types';
const MinecraftMangrovePropagule: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="9" y="1" width="1" height="1" fill="rgba(115, 198, 118, 255)" />
<rect x="10" y="1" width="1" height="1" fill="rgba(84, 178, 87, 255)" />
<rect x="8" y="2" width="1" height="1" fill="rgba(115, 198, 118, 255)" />
<rect x="9" y="2" width="1" height="1" fill="rgba(72, 165, 75, 255)" />
<rect x="10" y="2" width="1" height="1" fill="rgba(72, 130, 56, 255)" />
<rect x="5" y="3" width="1" height="1" fill="rgba(115, 198, 118, 255)" />
<rect x="6" y="3" width="1" height="1" fill="rgba(84, 178, 87, 255)" />
<rect x="8" y="3" width="1" height="1" fill="rgba(72, 165, 75, 255)" />
<rect x="9" y="3" width="1" height="1" fill="rgba(72, 130, 56, 255)" />
<rect x="4" y="4" width="1" height="1" fill="rgba(115, 198, 118, 255)" />
<rect x="5" y="4" width="1" height="1" fill="rgba(72, 130, 56, 255)" />
<rect x="6" y="4" width="1" height="1" fill="rgba(72, 165, 75, 255)" />
<rect x="7" y="4" width="1" height="1" fill="rgba(127, 191, 86, 255)" />
<rect x="7" y="5" width="1" height="1" fill="rgba(130, 145, 74, 255)" />
<rect x="7" y="6" width="1" height="1" fill="rgba(116, 130, 65, 255)" />
<rect x="6" y="7" width="1" height="1" fill="rgba(79, 195, 83, 255)" />
<rect x="7" y="7" width="1" height="1" fill="rgba(84, 178, 87, 255)" />
<rect x="8" y="7" width="1" height="1" fill="rgba(79, 195, 83, 255)" />
<rect x="6" y="8" width="1" height="1" fill="rgba(84, 178, 87, 255)" />
<rect x="7" y="8" width="1" height="1" fill="rgba(72, 165, 75, 255)" />
<rect x="8" y="8" width="1" height="1" fill="rgba(84, 178, 87, 255)" />
<rect x="6" y="9" width="1" height="1" fill="rgba(79, 195, 83, 255)" />
<rect x="7" y="9" width="1" height="1" fill="rgba(84, 178, 87, 255)" />
<rect x="8" y="9" width="1" height="1" fill="rgba(79, 195, 83, 255)" />
<rect x="6" y="10" width="1" height="1" fill="rgba(84, 178, 87, 255)" />
<rect x="7" y="10" width="1" height="1" fill="rgba(79, 195, 83, 255)" />
<rect x="8" y="10" width="1" height="1" fill="rgba(84, 178, 87, 255)" />
<rect x="6" y="11" width="1" height="1" fill="rgba(79, 195, 83, 255)" />
<rect x="7" y="11" width="1" height="1" fill="rgba(127, 191, 86, 255)" />
<rect x="8" y="11" width="1" height="1" fill="rgba(79, 195, 83, 255)" />
<rect x="6" y="12" width="1" height="1" fill="rgba(92, 209, 96, 255)" />
<rect x="7" y="12" width="1" height="1" fill="rgba(79, 195, 83, 255)" />
<rect x="8" y="12" width="1" height="1" fill="rgba(92, 209, 96, 255)" />
<rect x="6" y="13" width="1" height="1" fill="rgba(127, 191, 86, 255)" />
<rect x="7" y="13" width="1" height="1" fill="rgba(92, 209, 96, 255)" />
<rect x="8" y="13" width="1" height="1" fill="rgba(127, 191, 86, 255)" />
<rect x="6" y="14" width="1" height="1" fill="rgba(130, 145, 74, 255)" />
<rect x="7" y="14" width="1" height="1" fill="rgba(127, 191, 86, 255)" />
<rect x="8" y="14" width="1" height="1" fill="rgba(130, 145, 74, 255)" />
<rect x="6" y="15" width="1" height="1" fill="rgba(116, 130, 65, 255)" />
<rect x="7" y="15" width="1" height="1" fill="rgba(130, 145, 74, 255)" />
<rect x="8" y="15" width="1" height="1" fill="rgba(116, 130, 65, 255)" />
</svg>);
export default MinecraftMangrovePropagule;